import {
  ApolloClient,
  HttpLink,
  InMemoryCache,
  ApolloLink,
} from "@apollo/client";
import { onError } from "apollo-link-error";

//  WARNING: UAT Config
const base_url = "https://uat.api.pos.sababisha.com";

// WARNING: PRODUCTION Config
//const base_url = "https://api.njumu.pos.sababisha.com";
  
export const environment = process.env.NODE_ENV || "development";

const onErrorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, extensions }) => {
      if (
        extensions?.code === "SESSION_TERMINATED" ||
        extensions?.code === "UNAUTHENTICATED"
      ) {
        localStorage.setItem("logoutReason", "session_terminated");
        localStorage.removeItem("token");
        localStorage.removeItem("tokenExpiration");
        window.location.href = "/signin";
        return;
      }
      alert(`Graphql error ${message}`);
    });
  }

  if (networkError) {
    if (networkError.statusCode === 401) {
      const sessionExpired =
        networkError.response?.headers?.get?.("x-session-expired");
      const errorCode =
        networkError.result?.code ||
        networkError.result?.errors?.[0]?.extensions?.code;

      if (sessionExpired === "true" || errorCode === "SESSION_TERMINATED") {
        localStorage.setItem("logoutReason", "session_terminated");
        localStorage.removeItem("token");
        localStorage.removeItem("tokenExpiration");
        window.location.href = "/signin";
      }
    }
  }
});

const AppConfig = {
  USER_MANAGEMENT_URL: new HttpLink({
    uri: "https://localhost:44353/graphql/",
  }),
  ROLE_MANAGEMENT_URL: new HttpLink({
    uri: "https://localhost:44353/graphql/",
  }),
};

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  if (!token) {
    console.error("Token not found in localStorage");
    return {};
  }

  const formattedToken = `Bearer ${token.replace(/"/g, "")}`;

  return {
    Authorization: formattedToken,
  };
};

// Middleware to add authorization headers
const authMiddleware = new ApolloLink((operation, forward) => {
  const headers = getAuthHeaders();
  if (headers.Authorization) {
    operation.setContext({
      headers: {
        ...headers,
      },
    });
  } else {
    console.warn("Authorization header is missing");
  }

  return forward(operation);
});

export const createUsersClient = () => {
  const userManagementHttpLink = new HttpLink({
    uri: `${base_url}/POSUser`,
    //  uri: "https://localhost:7091/graphql/",
  });
  const userHttpLinkWithAuth = authMiddleware.concat(userManagementHttpLink);

  return new ApolloClient({
    link: onErrorLink.concat(userHttpLinkWithAuth),
    cache: new InMemoryCache(),
  });
};
//Role
export const createRoleClient = () => {
  const roleManagementHttpLink = new HttpLink({
    uri: `${base_url}/POSRole`,
  });
  const roleHttpLinkWithAuth = authMiddleware.concat(roleManagementHttpLink);

  return new ApolloClient({
    link: onErrorLink.concat(roleHttpLinkWithAuth),
    cache: new InMemoryCache(),
  });
};

export const createSetupClient = () => {
  const setupManagementHttpLink = new HttpLink({
    //uri: "https://uat.api.pos.sababisha.com/posgateway/POSSetupManagement",
    //   uri: "https://localhost:7266/graphql/",
    uri: `${base_url}/POSSetupManagement`,
  });
  
  const setupHttpLinkWithAuth = authMiddleware.concat(setupManagementHttpLink);

  return new ApolloClient({
    link: onErrorLink.concat(setupHttpLinkWithAuth),
    cache: new InMemoryCache(),
  });
};
export default AppConfig;

export const loginUrl = {
  login: `${base_url}/POSUser/login`,
  //login: "https://localhost:7173/userservice/login",
  // login: "https://localhost:7131/login/"
  // login: "https://uat.api.pos.sababisha.com/posgateway/POSUser/login",
};
export const roleManagemenUrl = {
  // uri:"https://localhost:7092/graphql"
  uri: `${base_url}/POSRole`,
};
export const userManagementUrl = {
  uri: `${base_url}/POSUser`,
  // uri: "https://localhost:7131/graphql/",
  //uri: "https://uat.api.pos.sababisha.com/POSUser",
};

export const MCBSwitchService = {
  // uri: "https://uat.api.pos.sababisha.com/posgateway/POSUser/mcbswitch",
  // uri: "https://localhost:7131/mcbswitch/",
  uri: `${base_url}/POSUser/mcbswitch`,
};

export const companyManagementUrl = {
  //uri: "https://uat.api.pos.sababisha.com/POSGateway/POSCompanyManagement",
  // uri: "https://localhost:7239/graphql/",
  uri: `${base_url}/POSCompanyManagement`,
  upload_logo_uri: `${base_url}/POSCompanyManagement/UploadLogo`,
  // uri:"https://localhost:7157/graphql/",
};

export const smsservice = {
  uri: `${base_url}/POSSMS`,
};

export const customerservice = {
  uri: `${base_url}/POSCustomer`,
  // uri: "https://localhost:7048/graphql/",
};
export const emailService = {
  uri: `${base_url}/POSemailservice`,
};
export const STKPushAttempt = {
  uri: `${base_url}/STKPushAttempt`,
  // uri:'https://localhost:7260/Mpesa/STKPushAttempt'
};
export const RequestUnlockOTP = {
  uri: `${base_url}/POSUser/requestunlockotp`,
};
export const VerifyUnlockOTP = {
  uri: `${base_url}/POSUser/verifyunlockotp`,
};
export const AccountsandFinanceurl = {
  // uri: "https://localhost:7237/graphql/",
  //uri: "https://uat.api.pos.sababisha.com/posgateway/POSaccountsmanagement",
  // uri: "https://localhost:7237/graphql/",
  uri: `${base_url}/POSaccountsmanagement`,
};

export const ForgetPasswordApiService = {
  uri: `${base_url}/POSUser/forgotpassword`,
};

export const setupManagementUrl = {
  // uri: "https://localhost:7210/graphql/",
  uri: `${base_url}/POSSetupManagement`,
};
export const inventoryManagementUrl = {
  // uri: "https://localhost:7223/graphql/",
  uri: `${base_url}/posinventory`,
};

export const uploadIndividualClients = {
  uri: "https://matrix.mcb.co.ke/gateway/Clientmanagement/uploadIndividualClients",
};
export const downloadIndividualClients = {
  uri: "https://matrix.mcb.co.ke/gateway/Clientmanagement/DownloadIndividualTemplate",
};
export const documentManagementUrl = {
  // uri: "https://localhost:7294/graphql",
  uri: `${base_url}/POSdocumentmanagement`,
  baseFilePath: `${base_url}/POSdocumentmanagement/ReadDocument?`,
  // baseFilePath: "https://matrix.mcb.co.ke/gateway/documentmanagement/ReadDocumentNoSecurity?"
};

export const salesManagement = {
  // uri: "https://uat.api.pos.sababisha.com/posgateway/POSsale",
  // uri: "https://localhost:7022/graphql",
  uri: `${base_url}/POSsale`,
};
export const notificationservice = {
  // uri:"https://localhost:7057/graphql/",
  uri: `${base_url}/POSNotifications`,
};

export const reportsManagementUrl = {
  //uri: "https://uat.api.pos.sababisha.com/posgateway/POSReports",
  // uri: "https://localhost:7056/graphql/",
  uri: `${base_url}/POSReports`,
  generate_report_uri: `${base_url}/mcbposengine/generateReport`, //'https://datapane.sababisha.mcb.co.ke/uatreports'// //${base_url}
   //generate_report_uri:
   //"http://127.0.0.1:5052/OPOReports/generateReport",
};
